export default __webpack_public_path__ + "static/media/mall91.2403fcd2.png";